<template lang="pug">
    div
        // :reduce="option => option.value"
        v-select(
            class="style-chooser"
            :options="options" 
            :multiple="multiple"
            :placeholder="$t('home.selectServiceGroupText')"
             @search="getOptionsDebounce"
            :filterable="false"
            v-model="serviceGroupNames"
            :taggable="taggable"
            :createOption="createOption"
        )
            template(slot="option" slot-scope="option")
                OptionSlot(:option="option")

            // template(slot="selected-option" slot-scope="option")
            //     span {{ option.value }}

            span(slot="no-options") {{ $t('main.selectNotFoundText') }}
</template>
<script>
import { getFormOptions } from "@/api/formoptions";
import { _debounce, isSameJson } from "@/libs/utils";
import OptionSlot from "@/components/rcmTableFormItems/Select/Options";

export default {
    name: "ServiceGroupNameSelector",
    components: { OptionSlot },
    props: {
        multiple: { type: Boolean, default: true },
        taggable: { type: Boolean, default: true },
    },
    watch: {
        groupNames: function(newVal, oldVal) {
            // console.log(`groupNames changed from ${oldVal} to ${newVal}`);
            if (!isSameJson(newVal, oldVal)) {
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serviceGroupNames", value: [] });
                this.getOptions();
            }
        }
    },
    data() {
        return {
            options: []
        };
    },
    computed: {
        groupNames() {
            let groupNames = this.$store.state.dashboard.queryFilter.groupNames;
            return groupNames.length > 0 ? groupNames : "*";
        },
        getOptionsQueryString() {
            let searchParams = {};
            searchParams.groupNames = this.groupNames;
            return new URLSearchParams(searchParams).toString();
        },
        serviceGroupNames: {
            get() {
                const list = this.$store.state.dashboard.queryFilter.serviceGroupNames;
                return list.map(v => ({
                    label: v,
                    value: v,
                }));
            },
            set(valueArray) {
                // this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serviceGroupNames", value });
                // console.log(`Trigger set valueObject`);
                // console.log(valueArray);
                let value = valueArray.map(e => (e.value ? e.value : e));
                value = [...new Set(value)];
                // console.log(value)
                this.$store.commit("SET_DASHBOARD_QUERY_FILTER", {
                    key: "serviceGroupNames",
                    value
                });
            }
        }
    },
    methods: {
        getOptions() {
            getFormOptions(`/servicegroupnames?${this.getOptionsQueryString}`).then(res => {
                this.options = Array.from(
                    new Map(
                        (res.data.options || []).map(o => [
                            o.value,
                            {
                                label: o.label,
                                value: o.value,
                            }
                        ])
                    ).values()
                );
            });
        },
        createOption(newOption) {
            return {
                label: newOption,
                value: newOption,
            };
        },
    },
    mounted() {
        this.getOptions();
    },
    created() {
        var self = this;
        this.getOptionsDebounce = _debounce(function(queryValue, loading) {
            // console.log(`Trigger debounce search for value: ${queryValue}`);
            loading(true);
            queryValue = queryValue || "";
            getFormOptions(`servicegroupnames?&serviceGroupNames=*${queryValue}*&${self.getOptionsQueryString}`).then(
                res => {
                    self.options = Array.from(
                        new Map(
                            (res.data.options || []).map(o => [
                                o.value,
                                {
                                    label: o.label,
                                    value: o.value,
                                }
                            ])
                        ).values()
                    );
                    loading(false);
                }
            );
        });
    },
    destroyed() {},
    beforeDestroy() {}
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/ServiceGroupNameSelector.vue